import { RatingFacetGroup } from 'client/pages/CheckboxGroup/RatingFacetGroup/RatingFacetGroup';
import { FacetType } from 'common/types/facet';
import { PLPGeneralFacetValue, PLPGroupedFacetValue } from 'common/types/plp-data';
import React, { FormEventHandler, useMemo } from 'react';
import { BrandFacetGroupStyled, CheckboxGroupStyled, DivStyled } from './FacetItem.styled';

export function FacetItemInternalsComponent({
  id,
  values,
  name,
  isBaseFacetType,
  onChange,
  onKeyDown,
}: {
  id: string;
  name: string;
  values: PLPGeneralFacetValue[] | PLPGroupedFacetValue[];
  isBaseFacetType: boolean;
  onChange: FormEventHandler<HTMLElement>;
  onKeyDown?: (event: React.KeyboardEvent<HTMLElement>) => void;
}) {
  const isColorFacetType = useMemo(
    () => id === FacetType.colours || id === FacetType.navcolour || id.includes('COLOUR'),
    [id],
  );

  return (
    <>
      <DivStyled />
      {id === FacetType.brand && values && (
        <BrandFacetGroupStyled
          groupDescription={`Filters for ${name}`}
          dataTestId="facet-checkbox--brand"
          groups={values as PLPGroupedFacetValue[]}
          onChange={onChange}
          onKeyDown={onKeyDown}
          groupID={name}
        />
      )}
      {isColorFacetType && (
        <CheckboxGroupStyled
          groupDescription={`Filters for ${name}`}
          dataTestId="facet-checkbox--colours"
          items={values as PLPGeneralFacetValue[]}
          isFullWidth
          isSwatch
          onChange={onChange}
          onKeyDown={onKeyDown}
          groupID={name}
        />
      )}
      {id === FacetType.rating && values && (
        <RatingFacetGroup
          groupDescription={`Filters for ${name}`}
          dataTestId="facet-checkbox--rating"
          items={values as PLPGeneralFacetValue[]}
          isFullWidth
          onChange={onChange}
          groupID={name}
        />
      )}
      {isBaseFacetType && values && !isColorFacetType && (
        <CheckboxGroupStyled
          groupDescription={`Filters for ${name}`}
          dataTestId="facet-checkbox--base"
          items={values as PLPGeneralFacetValue[]}
          isFullWidth
          onChange={onChange}
          onKeyDown={onKeyDown}
          groupID={name}
        />
      )}
    </>
  );
}

export const FacetItemInternals = React.memo(FacetItemInternalsComponent);
